module.exports = __webpack_public_path__ + "static/img/step1.b2d659f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step1.png
// module id = y5+m
// module chunks = 1